import ShowInfoModal from './ShowInfo';

export default ShowInfoModal;
